import type { FilterItem, PostFilterType } from '@/interfaces/component/filter.interface';
import { baseAppStorePostFilter } from '@/stores/appstore.store';

export const filtersMap: Record<PostFilterType, FilterItem> = {
  ALL: { label: '전체', value: 'ALL', option: baseAppStorePostFilter },
  NEGATIVE_POSTS_NO_ACTION: {
    label: '대응 필요 부정 리뷰',
    value: 'NEGATIVE_POSTS_NO_ACTION',
    option: {
      replyFilter: 'NO_REPLY',
      reviewType: 'NEGATIVE',
      hasProduct: false
    }
  },
  NO_REPLY: {
    label: '미답변 리뷰',
    value: 'NO_REPLY',
    option: { replyFilter: 'NO_REPLY' }
  },
  NEGATIVE_POSTS_ACTION_PROGRESS: {
    label: '삭제, 관리 리뷰',
    value: 'NEGATIVE_POSTS_ACTION_PROGRESS',
    option: {
      hasProduct: true
    },
    memberOnly: true
  },
  NEGATIVE_POSTS: {
    label: '부정 리뷰',
    value: 'NEGATIVE_POSTS',
    option: { reviewType: 'NEGATIVE' }
  },
  POSITIVE_POSTS: {
    label: '긍정 리뷰',
    value: 'POSITIVE_POSTS',
    option: { reviewType: 'POSITIVE' }
  },
  POSITIVE_WORDS: {
    label: '긍정 키워드',
    value: 'POSITIVE_WORDS',
    option: {},
    hasChild: true
  },
  NEGATIVE_WORDS: {
    label: '부정 키워드',
    value: 'NEGATIVE_WORDS',
    option: {},
    hasChild: true
  }
};

export const postFilters = [
  filtersMap.ALL,
  filtersMap.NEGATIVE_POSTS_NO_ACTION,
  filtersMap.NO_REPLY,
  filtersMap.NEGATIVE_POSTS_ACTION_PROGRESS,
  filtersMap.NEGATIVE_POSTS,
  filtersMap.POSITIVE_POSTS,
  filtersMap.POSITIVE_WORDS,
  filtersMap.NEGATIVE_WORDS
];
